// Recovered compiled webpack factory 20935. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "resolveHref", {
      enumerable: !0,
      get: function () {
        return p;
      },
    }));
  let n = r(33078),
    a = r(47670),
    o = r(13644),
    i = r(62296),
    s = r(71239),
    l = r(58607),
    u = r(55287),
    c = r(2471),
    f = r(98156),
    d = r(92385);
  function p(e, t, r) {
    let p,
      h = "string" == typeof t ? t : (0, a.formatWithValidation)(t),
      _ = h.match(/^[a-z][a-z0-9+.-]*:\/\//i),
      m = _ ? h.slice(_[0].length) : h;
    if ((m.split("?", 1)[0] || "").match(/(\/\/|\\)/)) {
      console.error(
        "Invalid href '" +
          h +
          "' passed to next/router in page: '" +
          e.pathname +
          "'. Repeated forward-slashes (//) or backslashes \\ are not valid in the href.",
      );
      let t = (0, i.normalizeRepeatedSlashes)(m);
      h = (_ ? _[0] : "") + t;
    }
    if (!(0, l.isLocalURL)(h)) return r ? [h] : h;
    try {
      let t = h.startsWith("#") ? e.asPath : e.pathname;
      if (h.startsWith("?") && ((t = e.asPath), (0, u.isDynamicRoute)(e.pathname))) {
        t = e.pathname;
        let r = (0, f.getRouteRegex)(e.pathname);
        (0, d.getRouteMatcher)(r)(e.asPath) || (t = e.asPath);
      }
      p = new URL(t, "http://n");
    } catch (e) {
      p = new URL("/", "http://n");
    }
    try {
      let e = new URL(h, p);
      e.pathname = (0, s.normalizePathTrailingSlash)(e.pathname);
      let t = "";
      if ((0, u.isDynamicRoute)(e.pathname) && e.searchParams && r) {
        let r = (0, n.searchParamsToUrlQuery)(e.searchParams),
          { result: i, params: s } = (0, c.interpolateAs)(e.pathname, e.pathname, r);
        i &&
          (t = (0, a.formatWithValidation)({
            pathname: i,
            hash: e.hash,
            query: (0, o.omit)(r, s),
          }));
      }
      let i = e.origin === p.origin ? e.href.slice(e.origin.length) : e.href;
      return r ? [i, t || i] : i;
    } catch (e) {
      return r ? [h] : h;
    }
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
